import React, { Fragment } from 'react';
import { Form, Select, Row, Col, Checkbox, Button, DatePicker, Radio } from 'antd';
import moment from 'moment';
import { CityComplete } from '~/components';
import { getCurrentLang, TripType, Languages, getTripType, combineUrl, config, animate, getValue4Lang } from '~/common';
import { FormattedMessage } from 'react-intl';

const { Option } = Select;

class SearchForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = { cities: [], tripType: 'return', isAdvanced: false }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.searchParam.multiFlights.length != this.props.searchParam.multiFlights.length) {
            this.setState({ tripType: this.props.searchParam.multiFlights.length == 1 ? 'one_way' : 'return' });
        }
    }

    handleAddFlight = () => {
        let param = this.props.searchParam;
        let newTrip = {};
        if (param.multiFlights.length >= 2) {
            if (!param.multiFlights[1].depCity && param.multiFlights[1].dstCity && param.multiFlights[0].depCity === param.multiFlights[1].dstCity) {
                param.multiFlights[1].dstCity = '';
            }
        }
        newTrip.depCity = param.multiFlights[0].dstCity;
        newTrip.dstCity = param.multiFlights[0].depCity;
        newTrip.isDepSchByAirport = param.multiFlights[0].isDstSchByAirport;
        newTrip.isDstSchByAirport = param.multiFlights[0].isDepSchByAirport;

        param.multiFlights.push(newTrip);
        this.props.handleSearchParamChange(param);
        this.handleAnimate();
    }

    handleAnimate = () => {
        this.state.isAdvanced && requestAnimationFrame(() => {
            const flightDom = document.querySelector('.flight-2');
            if (flightDom) {
                animate.slideDown(flightDom, 300);
            } else {
                this.handleAnimate();
            }
        });
    }

    handleDeleteTrip = tripIndex => {
        const doDelete = () => {
            let param = this.props.searchParam;
            param.multiFlights.splice(tripIndex, 1);
            this.props.handleSearchParamChange(param);
        };
        if (!this.state.isAdvanced) {
            doDelete();
            return;
        }
        const flightDom = document.querySelector('.flight-2');
        animate.slideUp(flightDom, 300, doDelete);
    }

    handleCityChange = (index, isDep, cityCode, isSchByAirport) => {
        let param = this.props.searchParam,
            trip = param.multiFlights[index],
            mapping = {
                '0': '1',
                '1': '0'
            };
        if (param.multiFlights.length === 2) {
            if (isDep) {
                param.multiFlights[index].depCity = cityCode;
                param.multiFlights[index].isDepSchByAirport = isSchByAirport;
                param.multiFlights[mapping[index]].dstCity = cityCode;
                param.multiFlights[mapping[index]].isDstSchByAirport = isSchByAirport;
            }
            else {
                param.multiFlights[index].dstCity = cityCode;
                param.multiFlights[index].isDstSchByAirport = isSchByAirport;
                param.multiFlights[mapping[index]].depCity = cityCode;
                param.multiFlights[mapping[index]].isDepSchByAirport = isSchByAirport;
            }

        } else {
            param.multiFlights[index][isDep ? 'depCity' : 'dstCity'] = cityCode;
            param.multiFlights[index][isDep ? 'isDepSchByAirport' : 'isDstSchByAirport'] = isSchByAirport;
        }
        if (cityCode) {
            try {
                if (isDep) {
                    if (!trip.dstCity) {
                        document.getElementById(`arr_city_${index}`).click();
                    }
                } else {
                    if (!trip.depDate) {
                        document.querySelectorAll('.fare-forecaster-form-wrapper .date-txt__wrap')[index].firstElementChild.firstElementChild.click();
                    }
                }
            } catch (ex) {
                console.log(ex);
            }
        }
        this.props.handleSearchParamChange(param);
    }

    handleDateChange = (index, date) => {
        let param = this.props.searchParam;
        date && (param.multiFlights[index].depDate = date.format('YYYYMMDD'));
        for (let i = index + 1; i < param.multiFlights.length; i++) {
            let prevTrip = param.multiFlights[i - 1];
            let trip = param.multiFlights[i];
            if (!trip.depDate || moment(trip.depDate).isBefore(prevTrip.depDate)) {
                trip.depDate = '';
                document.querySelectorAll('.fare-forecaster-form-wrapper .date-txt__wrap')[i].firstElementChild.firstElementChild.click();
            }
        }
        this.props.handleSearchParamChange(param);
    }

    disabledDate = (index, date) => {
        let today = moment().startOf('days');
        let endDate = moment().add(1, 'years').startOf('days');
        date = date.startOf('days');
        if (date.isBefore(today) || date.isAfter(endDate)) return true;
        let multiFlights = this.props.searchParam.multiFlights;
        if (index > 0 && multiFlights[index - 1].depDate) {
            if (date.isBefore(multiFlights[index - 1].depDate)) return true;
        }
        return false;
    }

    getCityName = (key, withCode) => {
        let name = (key + '').split('-')[0];
        if (key && this.props.citiesInfo && this.props.citiesInfo.size) {
            const cityInfo = this.props.citiesInfo.get(key);
            if (cityInfo) {
                name = getValue4Lang(cityInfo.name, cityInfo.name_zh_cn, cityInfo.name_zh_tw, cityInfo.name_ja_jp);
                name += withCode ? ` (${cityInfo.code})` : '';
            }
        }
        return name;
    }

    onTripTypeChange = (e) => {
        const tripType = e.target.value;
        this.setState({ tripType });
        const searchParam = this.props.searchParam;
        if (tripType == 'return') {
            searchParam.multiFlights.length == 1 && this.handleAddFlight();
        } else {
            searchParam.multiFlights.length == 2 && this.handleDeleteTrip(1);
        }
    }

    render() {
        const { searchParam, handleSearchParamChange, closeForm, handleToggleForm, handleSubmit, orgSearchParam, intl, isWidgets } = this.props;
        const { tripType, isAdvanced } = this.state;
        const formItemLayout = {
            labelCol: {
                span: 24,
            },
            wrapperCol: {
                span: 24,
            }
        }
        const formSubItemLayout = {
            wrapperCol: {
                sm: { span: 24 },
                md: { span: 6 },
            }
        }
        let orgTripType = getTripType(orgSearchParam && orgSearchParam.multiFlights);
        const flightImg = <img alt='->' src={combineUrl(config.localhostUrl, 'images/flight-dep.png')} width={15} style={{ margin: '-3px 5px 0', }} />;
        return (
            <Fragment>
                <div>
                    {!isWidgets && <Button onClick={handleToggleForm} className={`toggle-form-btn${closeForm ? ' close' : ''}`}><FormattedMessage id={closeForm ? 'update_search' : 'close_filters'} /></Button>}
                </div>

                <div className='fare-forecaster-panel' style={!closeForm ? { display: 'none' } : {}}>
                    {orgSearchParam ?
                        <Fragment>
                            <span className='panel-trip-type'><FormattedMessage id={orgTripType === TripType.Oneway ? 'one_way' : orgTripType === TripType.Roundtrip ? 'round_trip' : 'multi_city'} /></span>
                            {orgTripType !== TripType.MultiCity && <span className='panel-trip'>{this.getCityName(`${orgSearchParam.multiFlights[0].depCity}-${orgSearchParam.multiFlights[0].isDepSchByAirport ? 0 : 1}`, true)} {flightImg} {this.getCityName(`${orgSearchParam.multiFlights[0].dstCity}-${orgSearchParam.multiFlights[0].isDstSchByAirport ? 0 : 1}`, true)}</span>}
                            {orgTripType === TripType.MultiCity && <span>{orgSearchParam.multiFlights.map((trip, index) => {
                                return <span key={index} className='panel-trip'>{this.getCityName(`${trip.depCity}-${trip.isDepSchByAirport ? 0 : 1}`, true)} {flightImg} {this.getCityName(`${trip.dstCity}-${trip.isDstSchByAirport ? 0 : 1}`, true)}</span>;
                            })}</span>}
                        </Fragment>
                        : <Fragment>
                            <span className='panel-trip-type'><FormattedMessage id='round_trip' /></span>
                            <span className='panel-trip'><FormattedMessage id='enter_an_airport' /> {flightImg} <FormattedMessage id='enter_an_airport' /></span>
                        </Fragment>
                    }
                </div>

                <div className='fare-forecaster-form-wrapper' style={closeForm ? { display: 'none' } : {}}>
                    <Form onSubmit={handleSubmit} className="fare-forecaster-form ctm-ant-wrapper">

                        <Radio.Group onChange={this.onTripTypeChange} value={tripType} style={{ marginTop: 24, marginBottom: 24 }}>
                            <Radio.Button value="return">{intl.formatMessage({ id: 'return1' })}</Radio.Button>
                            <Radio.Button value="one_way">{intl.formatMessage({ id: 'one_way' })}</Radio.Button>
                        </Radio.Group>

                        {(() => {
                            const renderTrip = (trip, index, retTrip) => {
                                return (
                                    <Form.Item
                                        className={`flight-${index + 1}`}
                                        {...formItemLayout}
                                        style={{ marginBottom: 0 }}
                                        key={index}
                                    >
                                        <Row gutter={8} className='vertical-align-top'>
                                            {index == 0 && <Fragment>
                                                <Col {...formSubItemLayout.wrapperCol}>
                                                    <Form.Item {...formItemLayout} label={intl.formatMessage({ id: 'flight__from' })}>
                                                        <CityComplete
                                                            className='dep-city-txt__wrap input-require'
                                                            placeholder={intl.formatMessage({ id: 'where_from' })}
                                                            defaultValue={{ code: trip.depCity, isSchByAirport: trip.isDepSchByAirport }}
                                                            inputId={`dep_city_${index}`}
                                                            onSelect={(val, isSchByAirport) => this.handleCityChange(index, true, val, isSchByAirport)}
                                                            intl={intl}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col {...formSubItemLayout.wrapperCol}>
                                                    <Form.Item {...formItemLayout} label={intl.formatMessage({ id: 'flight__to' })}>
                                                        <CityComplete
                                                            className='arr-city-txt__wrap input-require'
                                                            placeholder={intl.formatMessage({ id: 'where_to' })}
                                                            defaultValue={{ code: trip.dstCity, isSchByAirport: trip.isDstSchByAirport }}
                                                            inputId={`arr_city_${index}`}
                                                            onSelect={(val, isSchByAirport) => this.handleCityChange(index, false, val, isSchByAirport)}
                                                            intl={intl}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Fragment>}
                                            <Col {...formSubItemLayout.wrapperCol}>
                                                <Form.Item {...formItemLayout} label={intl.formatMessage({ id: index == 0 ? 'departure_date' : 'return_date' })}>
                                                    <DatePicker
                                                        className='date-txt__wrap input-require'
                                                        value={trip.depDate ? moment(trip.depDate) : undefined}
                                                        format={getCurrentLang() === Languages.en_us ? 'DD MMM YYYY' : 'YYYY[年]MM[月]DD[日]'}
                                                        onChange={date => this.handleDateChange(index, date)}
                                                        style={{ width: '100%' }}
                                                        placeholder={intl.formatMessage({ id: 'select_date' })}
                                                        suffixIcon={<Fragment />}
                                                        showToday={false}
                                                        allowClear={false}
                                                        disabledDate={date => this.disabledDate(index, date)}
                                                        dropdownClassName='ctm-ant-wrapper'
                                                    />
                                                </Form.Item>
                                            </Col>
                                            {isAdvanced && <Col {...formSubItemLayout.wrapperCol}>
                                                <Form.Item {...formItemLayout} label={intl.formatMessage({ id: 'time_preference' })}>
                                                    <Select value={trip.depTime || ''} onChange={val => handleSearchParamChange({ ...searchParam, multiFlights: searchParam.multiFlights.map((v, i) => i === index ? { ...v, depTime: val } : v) })}>
                                                        <Option value=''><FormattedMessage id='any_time' /></Option>
                                                        <Option value='00:00-06:00'>00: 00 - 06: 00</Option>
                                                        <Option value='06:00-12:00'>06: 00 - 12: 00</Option>
                                                        <Option value='12:00-18:00'>12: 00 - 18: 00</Option>
                                                        <Option value='18:00-23:59'>18: 00 - 24: 00</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>}
                                            {!isAdvanced && tripType == 'return' && retTrip && <Col {...formSubItemLayout.wrapperCol}>
                                                <Form.Item {...formItemLayout} label={intl.formatMessage({ id: 'return_date' })}>
                                                    <DatePicker
                                                        className='date-txt__wrap input-require'
                                                        value={retTrip.depDate ? moment(retTrip.depDate) : undefined}
                                                        format={getCurrentLang() === Languages.en_us ? 'DD MMM YYYY' : 'YYYY[年]MM[月]DD[日]'}
                                                        onChange={date => this.handleDateChange(1, date)}
                                                        style={{ width: '100%' }}
                                                        placeholder={intl.formatMessage({ id: 'select_date' })}
                                                        suffixIcon={<Fragment />}
                                                        showToday={false}
                                                        allowClear={false}
                                                        disabledDate={date => this.disabledDate(1, date)}
                                                        dropdownClassName='ctm-ant-wrapper'
                                                        defaultPickerValue={trip.depDate ? moment(trip.depDate) : undefined}
                                                    />
                                                </Form.Item>
                                            </Col>}
                                        </Row>
                                    </Form.Item>
                                );
                            }
                            const depTrip = searchParam.multiFlights[0];
                            const retTrip = searchParam.multiFlights[1];
                            return <Fragment>
                                {renderTrip(depTrip, 0, retTrip)}
                                {isAdvanced && <div className='ff-advanced-dv'>
                                    {retTrip && renderTrip(retTrip, 1)}
                                    <Form.Item {...formItemLayout} label={<FormattedMessage id='cabin_class' />}>
                                        <Select value={searchParam.fareClass} onChange={val => handleSearchParamChange({ ...searchParam, fareClass: val })}>
                                            <Option value='Y'><FormattedMessage id='economy' /></Option>
                                            <Option value='S'><FormattedMessage id='premium_economy' /></Option>
                                            <Option value='C'><FormattedMessage id='business' /></Option>
                                            <Option value='F'><FormattedMessage id='first_class' /></Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item {...formItemLayout} label={<Checkbox checked={parseInt(searchParam.directFlight) ? true : false} onChange={e => handleSearchParamChange({ ...searchParam, directFlight: e.target.checked ? 1 : 0 })}><FormattedMessage id='direct' /></Checkbox>}></Form.Item>
                                </div>}
                            </Fragment>;
                        })()}

                        <Form.Item>
                            <button type='button' className='ctm-btn ctm-btn-link ctm-btn-basic' onClick={() => {
                                if (isAdvanced) {
                                    const el = document.querySelector('.ff-advanced-dv');
                                    animate.slideUp(el, 300, () => this.setState({ isAdvanced: !isAdvanced }));
                                } else {
                                    this.setState({ isAdvanced: !isAdvanced }, () => {
                                        const el = document.querySelector('.ff-advanced-dv');
                                        animate.slideDown(el, 300);
                                    });
                                }
                            }}>{intl.formatMessage({ id: isAdvanced ? 'general_search' : 'advanced_search' })}<span className={isAdvanced ? 'chevron-up-icon' : 'chevron-down-icon'}></span></button>
                        </Form.Item>
                        <div style={{ marginTop: 10, marginBottom: isWidgets ? 0 : 30, textAlign: 'right' }}>
                            <button type="submit" className="ctm-btn ctm-tile-btn"><FormattedMessage id='search' /></button>
                        </div>
                    </Form>
                </div>

            </Fragment>
        );
    }

}

const FareForecasterForm = Form.create()(SearchForm);

export default FareForecasterForm;